import React from 'react';
import { ContentBlock } from '../../../../common/index.jsx';
import PollsVoteForm from './PollsVoteForm.jsx';

const PollDynamicPage = ({ data, onSubmit }) => {
  const initials = {
    name: data?.name || null,
    questions: data?.questions
      ? [
          ...data.questions.map((singleQuestion) => ({
            response_collection_id: singleQuestion.id,
            name: singleQuestion.name,
            responses: singleQuestion.response_collection.responses.map(
              (singleResponse) => ({
                id: singleResponse.id,
                name: singleResponse.name,
              }),
            ),
          })),
        ]
      : [],
  };

  return (
    <div className="news-detail-page-container add-icons-to-file-anchors">
      <ContentBlock
        contentVisible
        blockWrapper="block-wrapper"
        contentWrapper="content-wrapper"
        shadow
        title={data.name}
      >
        <PollsVoteForm initialValues={initials} onSubmit={onSubmit} />
      </ContentBlock>
    </div>
  );
};
export default PollDynamicPage;
